const logotext = "NIHAL";
const meta = {
    title: "Nihal Gupta",
    description: "I’m Nihal Gupta Freelance Python Devloper + Full-stack Developer from India 🇮🇳",
};

const introdata = {
    title: "I’m Nihal Gupta",
    animated: {
        first: "Freelance Python Developer",
        second: "Full-stack Web Developer",
        third: "Smart India Hackathon Winner",
    },
    description: "Smart India Hackathon 2022 Winner|| Freelancer || B.Tech CSE Final Year || Python Developer || Full-Stack Web Developer (React + Django)",
    your_img_url: "https://github.com/noblenihal/Contact-Website/blob/main/images/set1/photo_6095951155021591443_y.jpg?raw=true",
};

const dataabout = {
    title: "A bit about my self",
    aboutme: `Hi, I'm Nihal Gupta, B-Tech Computer Science student at Maharaja Surajmal Institute of Technology, Delhi. 
    I am a full-stack developer well versed in front-end with HTML, CSS, JavaScript and ReactJS , and back-end with Django and Flask. I also have hands-on experience in writing Python Automation Scripts.
    
    Being a Tech-Lover, I am always fascinated by all the new technologies that are trending in the industry and I love to keep myself updated with them. 
    
    Apart from being a Tech-Person, I also like to work for the community because I think sharing is the most important thing that one should do for personal growth in life.
    
    I'm open for any kind of work and collaboration. 
    You can reach me at nihalgupta11213@gmail.com`,
};
const worktimeline = [{
        jobtitle: "Software Intern at AICTE, Ministry of Education",
        where: "New Delhi, India",
        date: "2022",
    },
    {
        jobtitle: "Freelance Python Developer",
        where: "Remote",
        date: "2022",
    },
];

const skills = [{
        name: "Python",
        value: 90,
    },
    {
        name: "Django",
        value: 85,
    },{
        name: "Flask",
        value: 75,
    },
    {
        name: "Javascript",
        value: 80,
    },{
        name: "HTML5",
        value: 90,
    },{
        name: "CSS",
        value: 80,
    },{
        name: "GIT",
        value: 75,
    },{
        name: "C/C++",
        value: 80,
    },{
        name: "Java",
        value: 60,
    },{
        name: "SQL",
        value: 75,
    },{
        name: "Linux",
        value: 60,
    },{
        name: "Data Structures",
        value: 80,
    },{
        name: "Algorithms",
        value: 80,
    },{
        name: "MySQL",
        value: 75,
    },{
        name: "PostgreSQL",
        value: 75,
    },
    {
        name: "React",
        value: 60,
    },
];

const services = [{
        title: "Smart India Hackathon 2022 Winner",
        description: "Our team 'Empathetic Coders' emerged as a winner in SIH 2022 under the problem statment 'AI based career couselling system' given by Department of School Education and Literacy, NDEAR",
    },
    {
        title: "Innovate NSUT Hackathon Winner",
        description: "Won the 1st prize at Innovate NSUT Hackathon organised by IOSD, Netaji Subhash University of Technology, Delhi",
    },
    {
        title: "Letter of Appreciation from Director, MSIT",
        description: "Received a Letter of Appreciation from the director of my college for organising fund raising event for underprivileged children",
    },
];

const dataportfolio = [{
        img: "https://res.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_1/n9ldn8pivgsrsbwcrs4s",
        desctiption: `Built ETL pipeline in python to collect option chains of 100 stocks in PostgreSQL DB using multithreading and web scrapping`,
        link: "https://gist.github.com/noblenihal/dfc67cbcee52f2fabb10860ef6536392",
        tags: ["Python", "SQL", "ETL", "Web Scraping", "Multithreading"]
    },
    {
        img: "https://msit.in/static/img/msit.png",
        desctiption: `Developed a Telegram based notification system for MSIT college with Python and SQL
        Sends notification whenever new circular or news is uploaded on official website
        `,
        link: "https://t.me/msitupdates",
        tags: ["Python", "SQL", "Web Scraping", "Bot"]
    },
    {
        img: "https://d112y698adiu2z.cloudfront.net/photos/production/software_thumbnail_photos/001/920/692/datas/medium.png",
        desctiption: `SUPER SUBTITLES - CHROME EXTENSION
        Developed a chrome extension to learn English through YouTube subtitles`,
        link: "https://github.com/supersubt/Super-Subtitles",
        tags: ["HTML", "CSS", "JavaScript"]
    },
    {
        img: "https://d112y698adiu2z.cloudfront.net/photos/production/software_thumbnail_photos/001/700/576/datas/medium.jpg",
        desctiption: "Attendo is a smarter and secure way for managing tedious tasks like attendance, making the life of teachers and students a lot easier!",
        link: "https://github.com/educate-app/Attendo-Web",
        tags: ["HTML", "CSS", "JavaScript", "ReactJS"]
    },
    {
        img: "https://avatars.githubusercontent.com/u/103312582?s=200&v=4",
        desctiption: "🎁 GiftaMatic - An opensource web3 project to create donation campaigns .",
        link: "https://github.com/GiftaMatic/giftamatic",
        tags: ["HTML", "CSS", "JavaScript", "ReactJS", "Tailwind", "Ant UI", "Web3"]
    },
];

const contactConfig = {
    YOUR_EMAIL: "nihalgupta11213@gmail.com",
    YOUR_FONE: "+919910719597",
    description: "I'm available 24 X 7",
    YOUR_SERVICE_ID: "service_n0a80nb",
    YOUR_TEMPLATE_ID: "template_j0j74ey",
    YOUR_USER_ID: "nihalgupta11213@gmail.com",
};

const socialprofils = {
    github: "https://github.com/noblenihal",
    facebook: "https://www.facebook.com/nihal.gupta.520/",
    linkedin: "https://www.linkedin.com/in/ng11213",
    twitter: "https://twitter.com/noblenihal",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
